<template>
  <div class="recovery-container">
    <div class="password-recovery">
      <h2 class="heading">Восстановление пароля</h2>
      <form class="form" @submit.prevent="recoveryPassword">
        <div class="form-group">
          <base-label class="form-label" for="email" :required="true">
            Email
          </base-label>
          <base-input
            type="email"
            id="email"
            v-model="email"
            placeholder="Email"
            class="form-input"
            :invalid="errors.email"
            @update:modelValue="errors.email = false"
          />
          <span class="error-message" v-if="errors.email">
            Поле обязательно для заполнения
          </span>
        </div>
        <div class="form-group">
          <base-label class="form-label" for="token" :required="true">
            Проверочный код
          </base-label>
          <base-input
            type="text"
            id="token"
            v-model="recoveryToken"
            placeholder="Проверочный код"
            class="form-input"
            :invalid="errors.recoveryToken"
            @update:modelValue="errors.recoveryToken = false"
          />
          <span class="error-message" v-if="errors.recoveryToken">
            Поле обязательно для заполнения
          </span>
        </div>
        <div class="form-group">
          <base-label
            class="form-label"
            for="new-password"
            :required="true"
          >
            Новый пароль
          </base-label>
          <base-input
            id="new-password"
            v-model="newPassword"
            is-password
            placeholder="Новый пароль"
            autocomplete="new-password"
            :clearable="false"
            class="form-input"
            :invalid="errors.newPassword"
            @update:modelValue="errors.newPassword = false"
          />
          <span class="error-message" v-if="errors.newPassword">
            Поле обязательно для заполнения
          </span>
        </div>
        <div class="form-group">
          <base-label
            class="form-label"
            for="confirmation-password"
            :required="true"
          >
            Подтверждение пароля
          </base-label>
          <base-input
            id="confirmation-password"
            v-model="newPasswordConfirmation"
            is-password
            placeholder="Подтверждение пароля"
            autocomplete="new-password"
            :clearable="false"
            class="form-input"
            :invalid="errors.newPasswordConfirmation"
            @update:modelValue="
              errors.newPasswordConfirmation = false
            "
          />
          <span
            class="error-message"
            v-if="errors.newPasswordConfirmation"
          >
            Поле обязательно для заполнения
          </span>
        </div>
        <base-error-container
          class="error-box"
          :error-container-msg="errorContainerMsg"
          variant="dark"
          v-show="errorContainerMsg.visible"
        />
        <div class="actions-box">
          <base-primary-button
            class="submit-btn"
            type="submit"
            :disabled="loading"
          >
            {{ loading ? "Сохранение..." : "Сохранить" }}
          </base-primary-button>
          <base-button
            class="cancel-btn"
            type="button"
            @click="goToLogin"
          >
            Отмена
          </base-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script type="text/javascript">
import usersApi from "../services/api/usersApi";
import { useNotificationStore } from "@/stores/notificationStore";

export default {
  name: "PasswordRecoveryPage",
  extends: {},
  props: {},
  data() {
    return {
      email: "",
      recoveryToken: "",
      newPassword: "",
      newPasswordConfirmation: "",

      errorContainerMsg: { visible: false, text: "Возникла ошибка" },
      errors: {
        email: false,
        recoveryToken: false,
        newPassword: false,
        newPasswordConfirmation: false,
      },

      loading: false,
    };
  },
  computed: {
    notificationStore() {
      return useNotificationStore();
    },
  },
  components: {},
  watch: {},
  methods: {
    validateForm() {
      this.errors = {
        email: false,
        recoveryToken: false,
        newPassword: false,
        newPasswordConfirmation: false,
      };

      let isValid = true;

      if (!this.email) {
        this.errors.email = true;
        isValid = false;
      }
      if (!this.recoveryToken) {
        this.errors.recoveryToken = true;
        isValid = false;
      }
      if (!this.newPassword) {
        this.errors.newPassword = true;
        isValid = false;
      }
      if (!this.newPasswordConfirmation) {
        this.errors.newPasswordConfirmation = true;
        isValid = false;
      }

      return isValid;
    },

    async recoveryPassword() {
      if (!this.validateForm()) return;

      this.loading = true;

      try {
        await usersApi.recoveryPassword({
          email: this.email,
          recovery_token: this.recoveryToken,
          password: this.newPassword,
          password_confirmation: this.newPasswordConfirmation,
        });
        this.loading = false;
        this.errorContainerMsg.visible = false;
        this.$router.push({ name: "Login" });
        this.notificationStore.showSuccess("Пароль успешно изменен");
      } catch (error) {
        this.loading = false;
        this.errorContainerMsg.text = error.response.data.errors;
        this.errorContainerMsg.visible = true;
      }
    },

    goToLogin() {
      this.$router.push({ name: "Login" });
    },
  },
  beforeCreate() {},
  created() {
    this.email = this.$route.query.email;
    this.recoveryToken = this.$route.query.recovery_token;
  },
  mounted() {},
};
</script>

<style scoped>
.recovery-container {
  display: flex;
  justify-content: center;
}

.password-recovery {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 15vh;
  padding: 50px;
  background-color: var(--color-dark);
  border-radius: 20px;
}

.heading {
  margin-bottom: 30px;
  color: #fff;
}

.form {
  width: 100%;
}

.form-label {
  color: #fff;
}

.error-message {
  display: block;
  margin-top: 5px;
  color: var(--color-danger);
  font-size: 14px;
}

.actions-box {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}

@media (max-width: 768px) {
  .recovery-container {
    height: 100vh;
    background-color: var(--color-dark);
  }
}
</style>
